import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import history from '../../../other/history';
import { questionLike, questionUnlike, questionEdit, repliesFetch, showLoginModal, linkPreviewFetch, completeLinkPreviewReset } from '../../../actions/index';
import { translate } from 'react-i18next';
// import style from './style.css';
import QuestionCardComponent from '../../../components/Elems/QuestionCard';
import ReplySortDropdown from '../../../components/Elems/ReplySortDropdown';
// import { ProfileThumb } from '../../../components/Common/CardComponents';
import ReplyCardContainer from '../ReplyCard';
import ReplyInputContainer from '../ReplyInput';
import GenericInputModal from '../../../components/Common/CardComponents/GenericInputModal';
import ShareModal from '../../../components/Common/CardComponents/Share';
import EmptyPlaceholder from '../../../components/Misc/EmptyPlaceholder';
import Filters from '../../../other/filters';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';
import {buildMapping} from '../../../other/ActionMapper';
import {myIsSet, esCape, gtmSend} from '../../../helpers';
import {Icon} from '../../../components/Common/Icon';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
// import {mobileCheck} from '../../../helpers';

import cx from '../../../styles';


class QuestionElemContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            replyPage: myIsSet(this.props, 'serverReqQuery.page') ? this.props.serverReqQuery.page : (Number(getUrlParameter('page')) || 1), 
            showNSFW: false,
            isEditModalOpen: false, 
            isShareModalOpen: false, 
            editTitle: '', 
            editContent: '',
            modalImages: [],
            modalGif: [],
            modalImagePreviews: [],
            isValidData: false,
            isLoading: false,
            likeErrorMessage: '',
            selectedSort: myIsSet(this.props, 'data.reply_sorting') ? this.props.data.reply_sorting.filter((opt) => {if(opt.selected) return true; else return false;})[0].label : ''
        };   
    }

    componentDidMount() {
        if (typeof this.refs.replyInput != "undefined") {
            this.replyInput = this.refs.replyInput.getWrappedInstance().getWrappedInstance();// coz of translate hoc
        }
        //
        if (history.location.state && 'shouldOpenQEditDialog' in history.location.state) {
            if (history.location.state.shouldOpenQEditDialog) {
                this.openEditModal();
            }
        }
        //nsfw
        this.setState({ showNSFW: !!this.props.data.topic.nsfw });
    }

    componentWillReceiveProps(nextProps) {
        //for edit reset
        if (this.props.postReducer.id && nextProps.postReducer.data.topic) {
            if (nextProps.postReducer.data.topic.message != this.props.postReducer.data.topic.message) {
                this.setState({
                    editTitle: nextProps.postReducer.data.topic.title,
                    editContent: nextProps.postReducer.data.topic.message
                });
            }
        }
    }

    goToSingleView = () => {
        window.location.href = `/q/${this.props.data.topic.slug}/${this.props.id}`
    }

    onReplyClick = () => {
        gtmSend('dynamic', 'Question Card', 'click-reply', this.props.match.path);
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `reply | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `reply | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            this.props.inFeed
                ? this.goToSingleView()
                : this.replyInput.openReplyModal();
            //this.goToSingleView({shouldOpenReplyDialog: true})
        }
    }

    onLikeClick = async () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `like | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `like | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else if(!this.state.isLoading){
            const { index, inFeed, id, data } = this.props;
            gtmSend('dynamic', 'Question Card', `click-${(data.likes.liked ? 'unlike' : 'like')}`, this.props.match.path);
            gtmSend('cw_reaction', 'Question Card', 'Reaction', `${(data.likes.liked ? 'unlike' : 'like')}`, 0, {card_type: 'Question Card', card_id: `${id}`, topic_name: `${data.topic.group.name}`, topic_id: `${data.topic.group.id}`});
            if(data.likes.liked){
                this.setState({isLoading: true});
                this.props.questionUnlike(index, inFeed, id)
                .then(() => {
                    this.setState({isLoading: false});
                });
            }
            else{
                this.setState({isLoading: true});
                await this.props.questionLike(index, inFeed, id)
                .then((data) => {
                    if(data){
                        this.setState({likeErrorMessage: data});
                    
                    }
                    this.setState({isLoading: false});
                });
            }
        }
    }

    imageUrlToData = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
            const reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    populatePostImages = (images = []) => {
        if (images.length) {
            if(images[0].type === 'gif'){
                this.setState({
                    modalGif: [images[0]]
                });
            }else{
                this.setState({
                    modalImagePreviews: [],
                    modalImages: [],
                    modalGif: []
                });
                for (const k in images) {
                    this.imageUrlToData(images[k].image, (d) => {
                        this.setState({
                            modalImagePreviews: [...this.state.modalImagePreviews, d],
                            modalImages: [...this.state.modalImages, d.split(',')[1]]
                        });
                    });
                }
            }
            //empty
        }
    }

    onEditModalImageUpload = (e) => {
        if (e.target.files.length) {
            gtmSend('dynamic', 'Question Card Edit', 'click-image-upload', '');
            for (let k = 0; k < e.target.files.length; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, base64Result],
                        modalImages: [...this.state.modalImages, base64Result.split(',')[1]]
                    });
                };
            }
        }
    }

    onPreviewImageRemove = (index) => {
        gtmSend('dynamic', 'Question Card Edit', 'click-remove-image-preview', '');
        this.setState({
            modalImagePreviews: [...this.state.modalImagePreviews.slice(0, index), ...this.state.modalImagePreviews.slice(index + 1)],
            modalImages: [...this.state.modalImages.slice(0, index), ...this.state.modalImages.slice(index + 1)]
        });
    }

    openEditModal = () => {
        this.setState({ isEditModalOpen: true });
    }

    closeEditModal = () => {
        const nsfw = !!this.props.data.topic.nsfw;
        if(this.state.showNSFW != nsfw){
            this.setState({showNSFW: nsfw});
        }
        this.setState({ isEditModalOpen: false, isValidData: false });
    }

    onEditModalOpen = () => {
        this.populatePostImages(this.props.data.topic.images);
        this.setState({
            editTitle: this.props.data.topic.title,
            editContent: this.props.data.topic.message
        });
        //dialog fix
        const state = {};
        history.replace({ ...history.location, state });
    }

    onEditModalSubmit = (e) => {
        this.setState({isValidData: true});
        e.preventDefault();
        const title = esCape(this.state.editTitle),
            message = esCape(this.state.editContent);
        if(message.length < 10) return this._addNotificationToModal(this.props.t('char_limit_desc'), 'error');
        if(title.length < 10) return this._addNotificationToModal(this.props.t('char_limit_title'), 'error');
        // let anonymous = e.target.anonymous.value;
        const nsfw = e.target.nsfw ? +(e.target.nsfw.checked) : 0,
            questionId = this.props.id;
        const gifId = e.target.gifId? e.target.gifId.value : '';
        // let isActive = 1;
        gtmSend('dynamic', 'Question Card Edit', 'click-submit', `submit:${questionId}`);
        let linkMatches = [];
        linkMatches = message.match(/([^.\s]+\.[^.\s]{2,}(?:\.[^.\s]{2,})*)/i);
        if(linkMatches && linkMatches.length) {
            const url = linkMatches[0].includes('http') ? linkMatches[0] : `https://${linkMatches[0]}`;
            if(url != this.props.composeReducer.linkPreview.url) {
                this.props.linkPreviewFetch(url);
            }
        }
        //
        if (this.state.modalImages.length) {
            let images = [];
            images = this.state.modalImages.map((image) => {return {image}});
            this.props.questionEdit(questionId, message, title, nsfw, images)
                .then(() =>{
                   if(!this.props.postReducer.error) {
                        this.closeEditModal();
                   }else {
                    this.setState({isValidData: false}); 
                    this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                   }
                });
        } else {
            this.props.questionEdit(questionId, message, title, nsfw, [], this.props.composeReducer.linkPreview.linkData || null, gifId ,myIsSet(this.props.composeReducer, 'linkPreview.linkData.type') ? 'video' : this.props.composeReducer.linkPreview.linkData && 'article')
                .then(() =>{
                    if(!this.props.postReducer.error) {
                        this.closeEditModal();
                    }else {
                    this.setState({isValidData: false});
                     this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                    }
                 });
        }
    }

    share = () => {
        gtmSend('dynamic', 'Question Card', 'click-share', this.props.match.path);
        this.setState({ isShareModalOpen: true });
    }

    onRepliesFetch = () => {
        if (!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `read more replies | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `read more replies | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        }
        else{
            if (this.props.singleReplyMode) {
                this.goToSingleView();
                // window.location.reload(true);
            } else {
                const page = this.state.replyPage;
                this.props.repliesFetch(this.props.id, Number(page) + 1, this.state.selectedSort)
                .then(() => {
                    if(this.props.userReducer.id){
                        this.setState({
                            replyPage: Number(page) + 1
                        });
                    }
                });
            }
        }
    }

    changeReplySorting = (value) => {
        this.setState({
            replyPage: (Number(getUrlParameter('page')) || 1),
            selectedSort: value
        });
    }

    nsfwHandler = () => {
        this.setState({ showNSFW: false });
    }

    onHashClick = (hashtag) => {
        let editContent = this.state.editContent;
        editContent += ` ${hashtag}`;
        this.setState({editContent});
        document.getElementById("content").focus();
    }

    onContentChange = (content) => {
        //set content
        this.setState({ editContent: content });
    }

    onLinkPreviewRemove = () => {
        gtmSend('dynamic', 'Question Card Edit', 'click-remove-link-preview', '');
        this.props.completeLinkPreviewReset();
    }

    render() {
        const {data, userReducer, appReducer, configReducer, postReducer, match, index, inFeed, id, t, singleReplyMode, status} = this.props,
            question = Filters.process(['feedhashtagify'], data.topic.message),
            title = data.topic.title,
            slug = data.topic.slug,
            nsfw = data.topic.nsfw,
            images = data.topic.images,
            topic = data.topic.group,
            author = data.topic.user,
            lastSeen = data.topic.nice_time,
            replies = data.replies,
            // ads = configReducer.ads,
            dfp = configReducer.dfp,
            url = data.topic.url,
            reply_count = data.topic.reply_count,
            responseBar = {
                replyCount: reply_count,
                likes: data.likes,
                onLikeClick: this.onLikeClick,
                onReplyClick: this.onReplyClick,
                onShareClick: this.share
            },
            actions = buildMapping(
                'question',
                data.actions,
                {
                    id,
                    cardName: 'Question Card',
                    authorId: author.id,
                    authorName: author.fullname,
                    hideUrl: data.hide_url,
                    position: (typeof document != 'undefined' ? document.documentElement.scrollTop : 0),
                    adminUrl: (data.backend_url ? data.backend_url : ''),
                    elemRef: this,
                    subType: this.props.subType,
                    detailPage: this.props.detailPage,
                    inFeed,
                    topic,
                    t
                },
                this.context.store.dispatch
            );
        // console.log(actions);
        return (
            <div 
                className={cx("question-elem-containers", inFeed ? "in-feed-design" : "detail-design")}>
                {
                    this.props.contentHub && 
                    <a className={cx('content-hub-overlay-wrapper')} href={url}></a>
                }
                
                <div className={cx("main-elem-section")}>
                    <QuestionCardComponent index={index}
                        siteUrl={configReducer.siteUrl}
                        question={Filters.process(['linkify'], question)}
                        title={title}
                        showNSFW={this.state.showNSFW}
                        nsfwHandler={this.nsfwHandler}
                        images={images}
                        viewUrl={`q/${slug}/${id}`}
                        inFeed={inFeed}
                        topic={topic}
                        author={author}
                        lastSeen={lastSeen}
                        actions={actions}
                        responseBar={responseBar}
                        onContentClick={this.goToSingleView} 
                        appReducer = {appReducer}
                        cardName='Question Card'
                        botIndex={data.topic.bot_index}
                        match={match}
                        status={status}
                        url={url}
                        id={id}
                        contentHub={this.props.contentHub}
                        likeErrorMessage={this.state.likeErrorMessage}/>
                </div>

                {
                    !(postReducer.data && postReducer.data.topic && postReducer.data.topic.nsfw === 1) &&
                    !inFeed && dfp.networkId && myIsSet(dfp, 'ros.banners.side_1.id') &&
                    <div className={cx("only-mobile", "ad-wrap", "shadow-card")}>
                        <AdCoreSlot 
                            dfpKeys={['ros','banners','side_1']}
                            adObj={dfp.ros.banners.side_1}
                            device="mobile"
                            customClass="showAddText"
                            styleClass={dfp.ros.banners.side_1.styleClass} 
                            id={dfp.ros.banners.side_1.id}
                            app={appReducer}
                        />
                    </div>
                }

                <div className={cx("reply-list-wrap")}>
                    {
                        !inFeed && replies.length != 0 &&
                        <ReplySortDropdown
                            t={t}
                            cardName='Question Card'
                            topic={topic}
                            replyCount={responseBar.replyCount}
                            reply_sorting={data.reply_sorting}
                            changeReplySorting={this.changeReplySorting}
                            selectedSort={this.state.selectedSort}
                            id={this.props.id}
                            repliesFetch={this.props.repliesFetch}
                        />
                    }

                    {
                        !inFeed &&
                        <div className={cx('shadow-card')}>
                            <ReplyInputContainer inFeed={inFeed}
                                id={id}
                                slug={slug}
                                ref='replyInput'
                                match= {match}
                                cardName='Question Card' />
                        </div>
                    }

                    {/*
                        !inFeed && ads.networkId &&
                        <div className={cx("only-mobile", "ad-wrap")}>
                            {
                                mobileCheck() && 
                                <AdCoreSlot networkId={ads.networkId} 
                                    adUnit={ads.mobile.top.unit}
                                    styleClass={ads.mobile.top.styleClass}
                                    size={[ads.mobile.top.w, ads.mobile.top.h]}
                                    id={ads.mobile.top.id} />
                            }
                        </div>
                    */}

                    {
                        replies.map((reply, i) => {
                            return <ReplyCardContainer key={i}
                                postId={id}
                                slug={slug}
                                cardIndex={index}
                                replyIndex={i}
                                reply={reply}
                                inFeed={inFeed}
                                singleReplyMode={singleReplyMode}
                                match={match}
                                status={status} 
                                topic={topic} />;
                        })
                    }

                    {
                        inFeed
                            ?
                            false && !!data.replies.length &&
                            <div className={cx("more-reply-link", "in-feed")}>
                                {
                                    data.more_reply_count == 0
                                        ?
                                        <span onClick={this.goToSingleView}>
                                            {`${data.more_reply_count} ${data.more_reply_count > 1 ? t('detail_reply_count_plural') : t('detail_reply_count')}`}
                                        </span>
                                        :
                                        ""
                                }

                                {!!data.more_reply_count && <Icon name="right-double-arrow-regular-gray-md" />}
                            </div>
                            :
                            !!data.more_reply_count &&
                            <div className={cx("more-reply-link")}>
                                <a href={`${match.url}?page=${Number(this.state.replyPage) + 1}`} className={cx("btn", "btn-primary")} onClick={(e) => {e.preventDefault(); this.onRepliesFetch();}}>
                                    <span>{`${data.more_reply_count} ${data.more_reply_count > 1 ? t('detail_reply_count_plural') : t('detail_reply_count')}`}</span>

                                    <Icon name="down-double-arrow-regular-white-md" />

                                    { postReducer.isLoading && !appReducer.showLoginModal && <span className={cx("spin-loader")} /> }
                                </a>
                            </div>
                    }
                </div>

                {
                    inFeed &&
                    <ReplyInputContainer inFeed={inFeed}
                        id={id}
                        slug={slug}
                        ref='replyInput'
                        match= {match}
                        cardName='Question Card' />
                }

                {
                    !(inFeed || data.replies.length) &&
                    <EmptyPlaceholder content={t('detail_empty_response_placeholder')} />
                }

                {
                    !inFeed &&
                    <GenericInputModal isModalOpen={this.state.isEditModalOpen}
                        eventHandlers={{
                            onModalOpen: this.onEditModalOpen,
                            onModalClose: () => this.setState({ isEditModalOpen: false }),
                            onSubmit: this.onEditModalSubmit,
                            onImageUpload: this.onEditModalImageUpload,
                            onPreviewImageRemove: this.onPreviewImageRemove,
                            onContentChange: this.onContentChange,
                            onHashClick: this.onHashClick,
                            onLinkPreviewRemove: this.onLinkPreviewRemove,
                            onTitleChange: v => this.setState({ editTitle: v }),
                            refAddNotification: (f) => this._addNotificationToModal = f,
                            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f,
                            onGifRemove: () => this.setState({modalGif : []})
                        }}
                        gtmLabel={'Question Card Edit'}
                        title={this.state.editTitle}
                        content={this.state.editContent}
                        imagePreviews={this.state.modalImagePreviews}
                        user={userReducer}
                        gifPreview={this.state.modalGif}
                        showUploadInput={true}
                        showUploadGif={true}
                        showNSFW={true}
                        showHash={true}
                        showUploadEmbed={true}
                        topic={topic}
                        isNSFWChecked={nsfw}
                        ifEditing={true}
                        buttonLabel={t('add_edit_save')}
                        linkPreview={this.props.composeReducer.linkPreview}
                        isValidData={this.state.isValidData} />
                }

                {
                    <ShareModal isModalOpen={this.state.isShareModalOpen}
                        position={typeof document != 'undefined' ? document.documentElement.scrollTop : 0}
                        shareType='question'
                        cardName= 'Question Card'
                        id={id}
                        siteUrl={configReducer.siteUrl}
                        slug={`q/${slug}/${id}`}
                        username={userReducer.full_name}
                        topic={topic}
                        t={t}
                        onModalClose={() => this.setState({ isShareModalOpen: false })} />
                }

            </div>
        );
    }

}

QuestionElemContainer.contextTypes = {
    store: PropTypes.object.isRequired
};

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionLike,
        questionUnlike,
        questionEdit,
        repliesFetch,
        showLoginModal,
        linkPreviewFetch,
        completeLinkPreviewReset
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(QuestionElemContainer));
